import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, combineLatest, of } from "rxjs";
import { catchError, map, switchMap, take, timeout } from "rxjs/operators";

import { StorageService } from "../../services/storage.service";
import { environment } from "../../../environments/environment";

/**
 * Se não houver cnpj cadastrado, ele abrirá a página de scanner para que seja redirecionado à uma rota
 */
@Injectable({
  providedIn: "root",
})
export class ScannerV2Guard implements CanActivate {
  constructor(private router: Router, private storage: StorageService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return combineLatest([this.storage.getV2<string>(environment.storage.cnpj).pipe(take(1)), this.storage.getV2<string>(environment.storage.appMode).pipe(take(1))]).pipe(
      switchMap(([cnpj, mode]) => {
        if (cnpj !== "" && mode !== "") {
          if (state.url.includes("home")) {
            return this.storage.getV2<string>(environment.storage.cnpj).pipe(
              take(1),
              map((cnpj) => !!cnpj || this.router.createUrlTree([environment.routePaths.v2.version, "config", cnpj, mode]))
            );
          } else {
            return of(!!route.params.cnpj || this.router.createUrlTree([environment.routePaths.v2.version, "config", cnpj, mode]));
          }
        } else {
          return of(false);
        }
      }),
      timeout(3000),
      catchError(() => of(false))
    );
  }
}
